var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowGoBack = function SvgArrowGoBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "m7.671 10.528 2.375 2.558-1.4 1.425L4 9.505 8.646 4.5l1.4 1.425L7.67 8.483h7.547c2.641 0 4.782 2.243 4.782 5.009S17.859 18.5 15.218 18.5h-4.307v-2.044h4.307c1.563 0 2.83-1.327 2.83-2.964s-1.267-2.965-2.83-2.965z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowGoBack;